import { AlertDialog, Button, ButtonGroup } from '@yaradigitallabs/ahua-react';
import type React from 'react';

type ReportConfirmationDialogProps = {
  open: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ReportConfirmationDialog: React.FC<
  ReportConfirmationDialogProps
> = ({ open, isLoading, onConfirm, onCancel }) => {
  return (
    <AlertDialog
      align="center"
      colorConcept="brand"
      iconSrc="Info"
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel();
        }
      }}
      type="icon"
    >
      <AlertDialog.Content>
        <AlertDialog.Start>
          <AlertDialog.Media
            align="center"
            colorConcept="brand"
            iconSrc="Info"
            type="icon"
          />
        </AlertDialog.Start>
        <AlertDialog.Middle>
          <AlertDialog.Title align="center">
            Report production?
          </AlertDialog.Title>
          <AlertDialog.Description align="center">
            Once reported, calculation methods cannot be changed. Make sure
            they're correct.
          </AlertDialog.Description>
        </AlertDialog.Middle>
        <AlertDialog.End>
          <ButtonGroup buttonWidth="block" orientation="vertical" size="s">
            <Button
              onClick={onConfirm}
              colorConcept="brand"
              loading={isLoading}
              loadingPosition="leading"
              disabled={isLoading}
            >
              Report
            </Button>
            <Button
              colorConcept="destructive"
              variant="ghost"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </AlertDialog.End>
      </AlertDialog.Content>
    </AlertDialog>
  );
};
